import { render } from "./z-checkbox.vue?vue&type=template&id=2d3978f0&lang=pug"
import script from "./z-checkbox.vue?vue&type=script&setup=true&lang=js"
export * from "./z-checkbox.vue?vue&type=script&setup=true&lang=js"

import "./z-checkbox.vue?vue&type=style&index=0&id=2d3978f0&lang=css"

import exportComponent from "E:\\D\\web\\pyCharm\\arhichat-3.4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__